import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[customDateMask]'
})

export class CustomDateMaskDirective {
  private regex: RegExp = new RegExp(/[^0-9\/]/g);

  private specialKeys = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event'])
  onkeypress(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = this.el.nativeElement.value;

    const next: string = current.concat(event.key);
    if (next && String(next).match(this.regex) || String(next).length > 10) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: KeyboardEvent) {
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event['clipboardData'].getData('Text'));

    if (next && String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: any) {
    event.dataTransfer.dropEffect = 'none';
    return event.preventDefault();
  }
}
